/**
 * Theme styles for ::meta syntax — header, close, block lines,
 * L0 pretty widget, L2 mark decorations.
 */

import { EditorView } from "@codemirror/view";
import {
    accentIconStyles,
    actionButtonStyles,
    accentText,
    directiveLineStyles,
    directivePrettyStyles,
} from "../shared/theme-helpers";

const META_ACCENT = "--cm-meta-accent";

export const metaTheme = EditorView.baseTheme({
    /* L2: Meta block header */
    ".cm-magic-meta-head": {
        color: `var(${META_ACCENT})`,
        fontWeight: "500",
        letterSpacing: "0.02em",
    },
    /* L2: Meta block close */
    ".cm-magic-meta-close": {
        color: `var(${META_ACCENT})`,
        fontWeight: "500",
        opacity: "0.7",
    },
    /* Background for all lines within a meta block */
    ".cm-magic-meta-line": directiveLineStyles(META_ACCENT, 6, 30),
    /* L0: Pretty meta widget */
    ".cm-magic-meta-pretty": directivePrettyStyles(META_ACCENT),
    ".cm-magic-meta-pretty-icon": accentIconStyles(META_ACCENT),
    ".cm-magic-meta-pretty-domain": accentText(META_ACCENT, {
        fontWeight: "600",
        letterSpacing: "0.01em",
    }),

    /* Meta button group — gold-themed border */
    ".cm-magic-meta-btn-group": {
        borderColor:
            "color-mix(in oklab, var(--cm-meta-accent) 35%, transparent)",
    },
    ".cm-magic-meta-btn-group .cm-magic-btn-config": actionButtonStyles(
        META_ACCENT,
    ),
    ".cm-magic-meta-btn-group .cm-magic-btn-snapshot": actionButtonStyles(
        META_ACCENT,
        { borderSide: "left" },
    ),
});
